/**
 * 
 * THIS WORKS FOR THE NEW EXTENSION
 * 
 */
export const extensionIdsByHostname = {
    'localhost': 'abpbkfhpjlidpeopnfjmlmmnabmnbeji',
    'my.ohio.pf.dev': '',
    'app.productfruits.com': 'blfcndbglccbobmkepikmbmobcehhkkf', // just to be sure, we use both prod domains
    'my.productfruits.com': 'blfcndbglccbobmkepikmbmobcehhkkf', // just to be sure, we use both prod domains
};

export function getExtensionIdByHostname() {
    return extensionIdsByHostname[window.location.hostname];
}

export function sendMessageToExtensionAsync(msgObject) {
    return new Promise((resolve) => {
        /** @ts-ignore */
        chrome.runtime.sendMessage(getExtensionIdByHostname(), msgObject, function (response) {
            /** @ts-ignore */
            if (!chrome.runtime.lastError) {
                resolve(response);
            } else {
                resolve(null);
            }
        });
    });
}

export function getExtensionDownloadLink() {
    return 'https://chrome.google.com/webstore/detail/' + getExtensionIdByHostname();
}

export function checkExtensionIsInstalledAsync() {
    console.log('checkingnew extension')
    return new Promise((success, error) => {
        const fullChromeExtUrl = `chrome-extension://${getExtensionIdByHostname()}/assets/test.png`;
        console.log('checkingnew extension inside')
        fetch(fullChromeExtUrl).then(() => {
            success(true);
        }).catch(() => {
            success(false);
        });
    });
}